import React from "react";
import { Row, Col, Card, Form } from "antd";

const FormItem = Form.Item;

const httpFromHttps = url => url.replace('http://', 'https://');

const PhotoDocument = props => {
  let imgFilter = props.photos.filter(photo => photo.hasOwnProperty("imageUrl") && photo.imageUrl !== "");
  return props.photos ? (
    <Row>
      {imgFilter.map((photo, index) => (
        <Col key={index} xs={24} md={24}>
          <Card title={photo.name}>
            <img
              id={photo.name + props.appraisalId}
              crossOrigin="anonymous"
              src={httpFromHttps(photo.imageUrl)}
              alt="img_doc"
              style={{
                  width: "100%",
                  height: 200,
                  objectFit: "cover",
              }}
              onClick={() => props.photoModal(true, photo)}
            />
            <FormItem label="Notes">
              <span className="ant-form-text">{photo.notes}</span>
            </FormItem>
          </Card>
        </Col>
      ))}
    </Row>
  ) : (
    "tidak ada gambar"
  );
};

export default PhotoDocument;



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/PDI/PhotoComponent/PhotoDocument.js